// import API_URL from "../API/API_URL";
import Cookies from "js-cookie";
const API_URL = process.env.REACT_APP_SERVER_URL


const UseLogin = async (userDetails) => {
  const response = await fetch(`${API_URL}/signin`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(userDetails),
  });
  const userToken = response.headers?.get("token");
  Cookies.set("usertoken", userToken, {
    expires: 1,
    path: "/",
  });

 

  const result = await response.json();
  return result;
};

export default UseLogin;
